import { useEffect, useState } from "react";
import { AdminHeader } from "../../../components/adminHeader/adminHeader";
import { useParams } from "react-router";
import AdminAPI from "../../../api/AdminAPI";
import styles from "./cafeFaq.module.css";
import { FAQItem } from "./faqItem";
import { usePopup } from "../../../components/popup/popup";
import { Separator } from "../../../components/separator/separator";
import { Button } from "../../../components/button/button";
import { Input } from "../../../components/input/input";
import { useConfirmPopup } from "../../../components/popup/confirmPopup/confirmPopup";

import { Text } from "../../../components/text/text";

export const CafeFAQ = () => {
    const { cafeId } = useParams();
    const [questions, setQuestions] = useState([]);

    const [Popup, open, close] = usePopup();

    const [curId, setCurId] = useState(null);
    const [question, setQuestion] = useState("");
    const [answer, setAnswer] = useState("");

    const onDelete = () => {
        if (!curId) return;

        AdminAPI
            .deleteQuestion(cafeId, curId)
            .then(() => setQuestions(prev => prev.filter(el => el.id !== curId)))
            .catch(console.error);
    }

    const [DeletePopup, openDelete] = useConfirmPopup(
        "Подтвердите действие",
        "Вы уверены, что хотите удалить вопрос?",
        onDelete
    )

    useEffect(() => {
        AdminAPI
            .fetchQuestions(cafeId)
            .then(setQuestions)
            .catch(console.error);
    }, [cafeId]);

    const [loading, setLoading] = useState(false);
    const onSave = () => {
        setLoading(true);
        if (curId) {
            AdminAPI
                .updateQuestion(cafeId, curId, question, answer)
                .then(res => setQuestions(prev => prev.map(el => el.id === curId ? res : el)))
                .catch(console.error)
                .finally(() => {
                    setLoading(false);
                    close();
                });
        } else {
            AdminAPI
                .createQuestion(cafeId, question, answer)
                .then(res => setQuestions(prev => [...prev, res]))
                .catch(console.error)
                .finally(() => {
                    setLoading(false);
                    close();
                });
        }
    }

    return (
        <>
            <AdminHeader title="FAQ" />

            <div className={styles.fuckyou}>
                {
                    questions.map(data => (
                        <FAQItem
                            key={data.id}
                            answer={data.answer}
                            question={data.question}
                            onEdit={() => {
                                setQuestion(data.question);
                                setAnswer(data.answer);
                                setCurId(data.id);
                                open();
                            }}
                            onDelete={() => {
                                setCurId(data.id);
                                openDelete();
                            }}
                        />
                    ))
                }
            </div>

            <Separator />

            <Button
                fixed
                text="Создать вопрос"
                onClick={() => {
                    setQuestion("");
                    setAnswer("");
                    setCurId(null);
                    open();
                }}
            />

            <Popup>
                <Text as="div" variant="h1" className={styles.title} >
                    {!curId ? "Создать вопрос" : "Редактировать вопрос"}
                </Text>

                <Input
                    label="Вопрос"
                    value={question}
                    setValue={setQuestion}
                />

                <Input
                    label="Ответ"
                    value={answer}
                    setValue={setAnswer}
                />

                <Button
                    text="Сохранить"
                    onClick={onSave}
                    disabled={loading}
                />
            </Popup>

            {DeletePopup}
        </>
    );
}